
export const apiRoute = {
    autocomplete: '/autocomplete',
    geocode: '/geocode',
    estimates: '/marketplace/building',
    submit: '/marketplace/submit',
    listingProfile: '/building'
}

export const httpMethod = {
    get: 'get',
    post: 'post',
    put: 'put',
    patch: 'patch',
    delete: 'delete'
}

export const filterLabels = {
    technology: 'technology',
    financing: 'financing',
    country: 'country'
}

export const country = {
    'US': 'us',
    'MX': 'mx',
    'Guatemala': 'guatemala',
    'Mexico': 'mexico'
}

export const technology = {
    'PV': 'pv',
    'Battery': 'battery',
    'CHP': 'chp',
    'Fuel Call': 'fuel call'
}

export const financing = {
    'CapEx': 'capex',
    'PPA': 'ppa',
    'Lease': 'lease'
}

export const gridmarketKey = '9pibbJMY7DyK7gEjf7Fc';

export const gridmarketStagingKey = 'J4X5mYiJe6Gjh3drPR7T';

export const onboardingComponents = {
    discoverSavings: 'discoverSavings',
    getStarted: 'getStarted'
}